import { RowSnapshot } from "./row-snapshot";

export class CreatePersonalBackupsRequest {
  packId: number | null = 0;
  name: string | null = null;
  titleIds: number[] | null = null;
  episodesListSelection: number[] | null = null;
  showColumIds: number[] | null = null;
  placeholderRowsSelected: RowSnapshot[] | null = null;

  constructor(init?: Partial<CreatePersonalBackupsRequest>) {
    Object.assign(this, init);
  }
}
